import { lazy } from 'react'

import ReactController from '~/controllers/react_controller'

export default class DynamicTableController extends ReactController {
  static values = {
    table: String,
    context: Object,
    data: Array,
    url: String,
    method: String,
    search: Object,
    sort: Object,
    exports: Array,
    polling: Object,
    visibilityToggle: Object,
    stickyFilters: Object,
    fixedQuery: Object,
  }

  createComponent() {
    // INFO: This is a mapping of the table names to the corresponding React components. The new table components
    // should be added here.
    const Tables = {
      simple: lazy(() => import('~/dashboard/tables/simple_table')),
    }

    if (!Object.keys(Tables).includes(this.tableValue)) {
      throw new Error(`The table "${this.tableValue}" is not registered in the DynamicTableController.`)
    }

    const Table = Tables[this.tableValue]

    return (
      <Table
        context={this.contextValue}
        data={this.dataValue}
        url={this.urlValue}
        method={this.methodValue}
        search={this.searchValue}
        sort={this.sortValue}
        exports={this.exportsValue}
        polling={this.pollingValue}
        visibilityToggle={this.visibilityToggleValue}
        stickyFilters={this.stickyFiltersValue}
        fixedQuery={this.fixedQueryValue}
      />
    )
  }
}
